import { useRef, useMemo } from "react";

import Actionbar from "src/components/common/actionbar/Authactionbar";
import { Message } from "src/components/common/form/Message";

import useUiuxStore from "src/store/useUiuxStore";

import { useMouseContent } from "src/utils/mouse/mouseContent";

import { Content_WMS1021_R01 } from "./Content_WMS1021_R01";
import { Info_WMS1021_R01 } from "./Info_WMS1021_R01";
import { useWMS1021_R01Store } from "./Store_WMS1021_R01";
import { AgGridReact } from "ag-grid-react";
import { WMS1021_R01DetailDto, WMS1021_R01HeaderDto } from "./Dto_WMS1021_R01";
import SearchSection_WMS1021_R01 from "./SearchSection_WMS1021_R01";
import { Table_WMS1021_R01 } from "./Table_WMS1021_R01";
import { DetailTable_WMS1021_R01 } from "./DetailTable_WMS1021_R01";


export const Container_WMS1021_R01 = () => {

	const { syncInitialData } = useWMS1021_R01Store();

	const { tabList, setMessage } = useUiuxStore();

	const RESIZER = {
		code: 'WMS1021_R01',
		type: 'width',
		storageKey: 'WMS1021_R01-split-width',
		min: 5,
		max: 80,
		default: 27
	} as const;
	const gridRef = useRef<AgGridReact<WMS1021_R01HeaderDto>>(null);
	const detailGridRef = useRef<AgGridReact<WMS1021_R01DetailDto>>(null);

	const containerRef = useRef<HTMLDivElement>(null);
	const infoRef = useRef<HTMLDivElement>(null);
	const isResizing = useRef(false);

	const { 
		splitValue,
		handleMouseDown,
	} = useMouseContent({
		resizer: RESIZER,
		isResizing,
		containerRef,
		infoRef
	});

	const V_RESIZER = {
		code: 'WMS1021_R01',
		type: 'height',
		storageKey: 'WMS1021_R01-info-split-height',
		min: 5,
		max: 80,
		default: 30
	} as const;
	const rightTopRef = useRef<HTMLDivElement>(null);
	const isVResizing = useRef(false);

	const { 
		splitValue: vSplitValue,
		handleMouseDown: handleVMouseDown,
	} = useMouseContent({
		resizer: V_RESIZER,
		isResizing: isVResizing,
		containerRef: infoRef,
		infoRef: rightTopRef
	});

	const {
		handleExcelClick,
		fetchData,
		defaultWMS1021_R01HeaderRow,
		defaultWMS1021_R01DetailRow,
		initContainerData,
		handleDeleteClick,
		handleCreateClick,
		handleSaveClick,
		handleDetailInfoCode,
		handleFetchDetailList,
	} = Content_WMS1021_R01({
		gridRef,
		detailGridRef,
		tabList, setMessage,
		containerRef,
		isResizing,
	});

	useMemo(() => { syncInitialData(); }, []);

	return <div className={`content-container`}>
		
		<Actionbar
			onFetchClick={fetchData}
			onCreateClick={() => {}}
			onDeleteClick={handleDeleteClick}
			onSaveClick={handleSaveClick}
			onPrintClick={() => {}}
			onExcelClick={handleExcelClick}
			onInitClick={initContainerData}
		/>
		<SearchSection_WMS1021_R01 onEnterKeyDown={() => { fetchData(); }} />

		<div className="flex flex-1 p-[12px] gap-[4px] min-h-0"
			ref={containerRef}>
			<div className="h-full" style={{ width: `${splitValue}%` }}>
				<Table_WMS1021_R01 gridRef={gridRef} handleCreateClick={handleCreateClick} defaultWMS1021_R01HeaderRow={defaultWMS1021_R01HeaderRow()} />
			</div>
			<div
				className="w-[6px] bg-gray-100 cursor-col-resize hover:bg-gray-300"
				onMouseDown={(e: React.MouseEvent<HTMLDivElement>) => handleMouseDown('LR', e.nativeEvent)}
				data-comment="리사이저"
			/>
			<div className="h-full flex flex-col gap-[4px]" style={{ width: `${100 - splitValue}%` }} ref={infoRef}>
				<div style={{ height: `${vSplitValue}%`, maxHeight: `${vSplitValue}%` }} ref={rightTopRef}>
					<Info_WMS1021_R01 
						editable={false}
						defaultWMS1021_R01HeaderRow={defaultWMS1021_R01HeaderRow()}
						handleDetailInfoCode={handleDetailInfoCode} handleFetchDetailList={handleFetchDetailList}
					/>
				</div>
				<div
					className="h-[6px] bg-gray-100 cursor-row-resize hover:bg-gray-300"
					onMouseDown={(e: React.MouseEvent<HTMLDivElement>) => handleVMouseDown("UD", e.nativeEvent) }
				/>
				<div style={{ height: `${100 - vSplitValue}%` }} className="pb-[12px] flex flex-1 min-w-0">
					<DetailTable_WMS1021_R01 
						detailGridRef={detailGridRef} 
						defaultWMS1021_R01DetailRow={defaultWMS1021_R01DetailRow()}
					/>
				</div>
			</div>
		</div>
		<Message />
	</div>
}
